module.exports = __webpack_public_path__ + "static/img/1.ca29400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon/1.png
// module id = FVVI
// module chunks = 0